export const updateTotalValue = (row, previousCellValue, value, key) => ({
  ...row[key],
  value: row[key].value - previousCellValue + value,
});

export const mapAffectedTotalsToStateUpdates = (affectedTotals, row, previousCellValue, value) => affectedTotals
  .map(totalToUpdate => ({
    [totalToUpdate]: updateTotalValue(row, previousCellValue, value, totalToUpdate),
  }))
  .reduce((result, next) => ({ ...result, ...next }), {});
